import React from 'react'
import PropTypes from 'prop-types'
import { Route, Redirect } from 'react-router-dom'


const ProtectedRoute =  ({ component: Comp, props: componentProps, ...rest }) =>{

    const render = (props) =>{
        const {user} = componentProps || {}
        const {location} = props
        console.log('component props', componentProps)
        return user ? <Comp {...props} {...componentProps} />
            : <Redirect to={`/login?redirect=${location.pathname}${location.search}`}/>
    }

    return (<Route {...rest} render={render}/>)
}

ProtectedRoute.propTypes = {
    props: PropTypes.any,
    component: PropTypes.any,
    location: PropTypes.any
}

export default ProtectedRoute


// WEBPACK FOOTER //
// ./src/components/app/protectedRoute.js